import { ApprovalType } from '@/types/api';
import React from 'react';
import { useAtom } from 'jotai';
import { approvalFilter, approvalTempFilter } from '@/recoil/atom';
import { WorkEventName, WorkPageAreaType } from '@/constant/gtm';
import { useWorkEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import Checkbox from '@/components/@IntranetLibrary/Checkbox';

type P = {
  pageArea: WorkPageAreaType;
  content: ApprovalType;
};

const ApprovalCheckBox = ({ pageArea, content }: P) => {
  const workEventTracker = useWorkEventTracker(pageArea);
  const [filters, setFilters] = useAtom(approvalFilter);
  const [tempFilters, setTempFilters] = useAtom(approvalTempFilter);

  const isChecked = filters.types.some(
    (res: ApprovalType) => res.type === content.type,
  );

  const handleChange = () => {
    if (isChecked) {
      setFilters({
        ...filters,
        types: filters.types.filter((res) => res.type !== content.type),
      });
    } else {
      setFilters({
        ...filters,
        types: [...filters.types, content],
      });
    }

    // GA Work - Approval 32번
    workEventTracker(WorkEventName.clickEvent, {
      area_name: '양식_필터',
      contents: content.name,
      status: !isChecked,
      description: '품의 양식 필터 선택',
    });

    //TEMP_FILTER
    if (!tempFilters.types.some((item) => item.type === content.type)) {
      setTempFilters({
        ...tempFilters,
        types: [...tempFilters.types, content],
      });
    }
  };
  return (
    <div
      key={content.type}
      className={'v2cb-hover-target'}
      style={{
        width: '33%',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
      }}
      onClick={handleChange}
    >
      <Checkbox checked={isChecked} sx={{ padding: 0 }} />
      <div>{content.name}</div>
    </div>
  );
};

export default ApprovalCheckBox;
